const KIOSK_TOKEN_KEY = 'kiosk_token';
const KIOSK_REFRESH_TOKEN_KEY = 'kiosk_refresh_token';
const KIOSK_ID_TOKEN_KEY = 'kiosk_id_token';
const KIOSK_TIME_SKEW_KEY = 'kiosk_time_skew';

const parseTimeSkew = (value: string | null): number | null => {
  if (value === null) return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const getKioskPersistedTokens = (): {
  token: string | null;
  refreshToken: string | null;
  idToken: string | null;
  timeSkew: number | null;
} => ({
  token: localStorage.getItem(KIOSK_TOKEN_KEY),
  refreshToken: localStorage.getItem(KIOSK_REFRESH_TOKEN_KEY),
  idToken: localStorage.getItem(KIOSK_ID_TOKEN_KEY),
  timeSkew: parseTimeSkew(localStorage.getItem(KIOSK_TIME_SKEW_KEY)),
});

export const persistKioskTokens = (token: string, refreshToken: string, idToken: string, timeSkew: number): void => {
  localStorage.setItem(KIOSK_TOKEN_KEY, token);
  localStorage.setItem(KIOSK_REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(KIOSK_ID_TOKEN_KEY, idToken);
  localStorage.setItem(KIOSK_TIME_SKEW_KEY, timeSkew.toString());
};

export const clearKioskPersistedTokens = (): void => {
  localStorage.removeItem(KIOSK_TOKEN_KEY);
  localStorage.removeItem(KIOSK_REFRESH_TOKEN_KEY);
  localStorage.removeItem(KIOSK_ID_TOKEN_KEY);
  localStorage.removeItem(KIOSK_TIME_SKEW_KEY);
};
